import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { InputMask } from "primereact/inputmask";


import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import Card from "../../../../../Base/Components/Card/Card";
import { getDateTimeStringSQL } from "../../../../../Base/Services/Moment/Luxon";


import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import { EditarSubActivosFijos, GuardarSubActivosFijos, getActivosFijos, getCodSubAct } from "../../../../../API/Global/ActivosFijos/ActivosFijosRequest";
import { getTasaCambio } from "../../../../../API/CalendarioOperativo/CalendarioOperativoRequest";

const SubActivosCRUD = ({
  toastRef,
  showDialog,
  selected,
  setSelected,
  setShowDialog,
  getInfo,
  modo,
  IdActivo = null,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [estados, setEstados] = useState([]);
  const [activosFijos, setActivosFijos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [codigoSubActivo, setCodigoSubActivo] = useState([]);
  const [tasaCambio, setTasaCambio] = useState([]);


  const initialValues = {
    IdSubActivo: -1,
    CodigoSubActivo: '',
    NombreSubActivo:"",
    // IdEstado: selected ? selected?.IdStatus : 110,
    AbbreviatedType: '',
    Comentario: '',
    IdActivo: IdActivo ? IdActivo : null
  };

  const { values, handleInputChange, setValues, resetForm, error, setError, setNumber} = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const codigoTempo = await getCodSubAct();
    setCodigoSubActivo(codigoTempo[0]?.NumeroCorrelativo)

    const b = await getActivosFijos();
    setActivosFijos(b.filter((i) => i?.ActivoPadre === false));

    const estadosTempo = await getEstadosCategory("ActivosFijos");
    setEstados(estadosTempo);

    const tasaCambioTempo = await getTasaCambio()
    setTasaCambio(tasaCambioTempo[0]?.TasaCambio)

    const estadoInicial = modo === "Crear" ? estadosTempo[0] : estadosTempo.find((e) => e.IdStatus === selected?.IdStatus);

    setValues({
      ...selected,
      IdSubActivo: selected ? selected?.IdSubActivo : -100,
      CodigoSubActivo: selected ? selected?.CodigoSubActivo : codigoTempo[0]?.NumeroCorrelativo,
      // Estado: estadoInicial,
      ActivoFijo:IdActivo ? b.find((t) => IdActivo === t.IdActivo) : b.find((t) => selected?.IdActivo === t.IdActivo),
      // IdEstado: estadoInicial?.IdStatus,
      TasaCambio: tasaCambioTempo[0]?.TasaCambio,
      FechaAdquisicion: selected ? new Date(selected?.FechaAdquisicion) : null,
      FechaUso: selected ? new Date(selected?.FechaUso) : null,
    });

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setSelected(null)
  };


  const verificarInfo = () => {
    let error = {};

    if (!values.NombreSubActivo) {
      error.NombreSubActivo = true;
      error.error = true;
    }
    
    if (!values.ActivoFijo?.IdActivo) {
      error.ActivoFijo = true;
      error.error = true;
    }

    if (!values.FechaAdquisicion) {
      error.FechaAdquisicion = true;
      error.error = true;
    }
    
    if (!values.FechaUso) {
      error.FechaUso = true;
      error.error = true;
    }
    
    if (!values.Valor) {
      error.Valor = true;
      error.error = true;
    }
    
    if (!values.TasaCambio) {
      error.TasaCambio = true;
      error.error = true;
    }
    
    // if (!values.Estado || !values.Estado.IdStatus) {
    //   error.Estado = true;
    //   error.error = true;
    // }

    setError(error);
    return error;
  };

  const agregarSubActivo = async () => {
    const e = verificarInfo();
    if (!e.error) {

      const Datos = {
        IdSubActivo: values?.IdSubActivo,
        NombreSubActivo: values?.NombreSubActivo,
        IdActivo: values?.ActivoFijo?.IdActivo,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
        FechaAdquisicion: getDateTimeStringSQL(values.FechaAdquisicion),
        FechaUso: getDateTimeStringSQL(values.FechaUso),
        Valor: values?.Valor,
        ValorD: values?.ValorD,
        TasaCambio: values?.TasaCambio,
        VidaUtil: values?.VidaUtil,
        Comentario: values?.Comentario,
        // IdStatus: values?.Estado.IdStatus,
        Marca: values?.Marca,
        Modelo: values?.Modelo,
        Serie: values?.Serie,
        Ano: values?.Ano,
      };

      if (Datos.IdSubActivo > 0) {
        setLoading(true);
        const resultado = await EditarSubActivosFijos(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Editados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error", resultado[0]?.MENSAJE);
          setLoading(false);
        }
      } else {
        const resultado = await GuardarSubActivosFijos(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error", resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarSubActivo}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  useEffect(() => {
    const tasaC = values.TasaCambio || tasaCambio;
    if (values.Valor && tasaC) {
      setValues((prevValues) => ({
        ...prevValues,
        ValorD: (values.Valor / tasaC).toFixed(2),
      }));
    }
  }, [values.Valor, values.TasaCambio, tasaCambio]);


  const dialogTitle = modo === "Crear" ? "Agregar SubActivo Fijo" : "Modificar SubActivo Fijo";

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
      >
        <Toast ref={toast} />

        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100%", margin: "auto" }}>
            <Card
              titulo={<h4>Sub Activo</h4>}
              contenido={
                <div className="mb-4">
                  <div className="modal__input-contenedor">

                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputText
                          name="NombreSubActivo"
                          value={values.NombreSubActivo}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.NombreSubActivo ? "p-invalid" : ""}
                        />
                        <label htmlFor="NombreSubActivo">Nombre SubActivo</label>
                      </span>
                    </div>
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"ActivoFijo"}
                          value={values.ActivoFijo}
                          items={activosFijos}
                          field={"NombreActivo"}
                          label={"Activo Fijo"}
                          handleInputChange={handleInputChange}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.ActivoFijo ? "p-invalid" : ""}
                        />
                      </span>
                    </div>

                    {/* <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"Estado"}
                          value={values.Estado}
                          items={estados}
                          field={"StatusName"}
                          label={"Estado"}
                          style={{ width: "100%" }}
                          handleInputChange={handleInputChange}
                          className={error?.Estado && "p-invalid"}
                        />
                      </span>
                    </div> */}
                  </div>

                  <div className="modal__input-contenedor">
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <Calendar
                          selectionMode="single"
                          value={values?.FechaAdquisicion}
                          onChange={handleInputChange}
                          name="FechaAdquisicion"
                          style={{ width: "100%" }}
                          dateFormat={"dd/mm/yy"}
                          showIcon
                          className={error.FechaAdquisicion ? "p-invalid" : ""}
                        />
                        <label htmlFor="righticon">Fecha Adquisición</label>
                      </span>
                    </div>
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <Calendar
                          dateFormat={"dd/mm/yy"}
                          selectionMode="single"
                          value={values?.FechaUso}
                          onChange={handleInputChange}
                          name="FechaUso"
                          style={{ width: "100%" }}
                          minDate={values?.FechaAdquisicion}
                          showIcon
                          className={error.FechaUso ? "p-invalid" : ""}
                        />
                        <label htmlFor="righticon">Fecha uso</label>
                      </span>
                    </div>

                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputText
                          name="Marca"
                          value={values.Marca}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.Marca ? "p-invalid" : ""}
                        />
                        <label htmlFor="Marca">Marca</label>
                      </span>
                    </div>


                  </div>

                  <div className="modal__input-contenedor">
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputText
                          name="Modelo"
                          value={values.Modelo}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.Modelo ? "p-invalid" : ""}
                        />
                        <label htmlFor="Modelo">Modelo</label>
                      </span>
                    </div>
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputText
                          name="Serie"
                          value={values.Serie}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.Serie ? "p-invalid" : ""}
                        />
                        <label htmlFor="Serie">Serie</label>
                      </span>
                    </div>

                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputMask
                          name="Ano"
                          mask="9999"
                          value={values.Ano}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.Ano ? "p-invalid" : ""}
                        />
                        <label htmlFor="Ano">Año</label>
                      </span>
                    </div>
    
                  </div>

                  <div className="modal__input-contenedor">

                    <div className="field col-12 me-2 mt-2">
                      <span className="p-float-label">
                        <InputTextarea
                          name="Comentario"
                          value={values.Comentario}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.Comentario ? "p-invalid" : ""}
                        />
                        <label htmlFor="Comentario">Comentario</label>
                      </span>
                    </div>
                  </div>
                </div>
              }
            ></Card>

            <Card
              titulo={<h4>Valor</h4>}
              contenido={
                <div className="mb-4">
                  <div className="modal__input-contenedor">
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputNumber
                          id="righticon"
                          value={values?.Valor}
                          onChange={(e) => setNumber(e, "Valor")}
                          name={"Valor"}
                          style={{ width: "100%" }}
                          mode="decimal"
                          prefix="L "
                          minFractionDigits={2}
                          maxFractionDigits={4}
                          className={error.Valor ? "p-invalid" : ""}
                        />
                        <label htmlFor="righticon">Valor activo Lempiras</label>
                      </span>
                    </div>
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputNumber
                          id="righticon"
                          value={values?.ValorD}
                          onChange={(e) => setNumber(e, "ValorD")}
                          name={"ValorD"}
                          style={{ width: "100%" }}
                          mode="decimal"
                          prefix="$ "
                          minFractionDigits={2}
                          maxFractionDigits={4}
                          disabled
                        />
                        <label htmlFor="righticon">Valor activo Dolares</label>
                      </span>
                    </div>

                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputNumber
                          id="righticon"
                          value={values?.VidaUtil}
                          onChange={(e) => setNumber(e, "VidaUtil")}
                          name={"VidaUtil"}
                          mode="decimal"
                          suffix=" años"
                          style={{ width: "100%" }}
                          className={error.VidaUtil ? "p-invalid" : ""}
                          // minFractionDigits={2}
                        />
                        <label htmlFor="righticon">Vida util</label>
                      </span>
                    </div>
                  </div>

                  <div className="modal__input-contenedor">
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputNumber
                          value={
                            values?.VidaUtil ? (1 / values.VidaUtil) * 100 : 0
                          }
                          suffix=" %"
                          disabled
                          style={{ width: "100%" }}
                        />
                        <label htmlFor="righticon">
                          Porcentaje de depreciación
                        </label>
                      </span>
                    </div>
                    <div className="field col-4 me-2 mt-2">
                      <span className="p-float-label">
                        <InputNumber
                          id="righticon"
                          value={values?.TasaCambio || tasaCambio}
                          onChange={handleInputChange}
                          name={"TasaCambio"}
                          minFractionDigits={4}
                          style={{ width: "100%" }}
                        />
                        <label htmlFor="righticon">Tasa de Cambio</label>
                      </span>
                    </div>
                  </div>
                </div>
              }
            ></Card>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default SubActivosCRUD;
